var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop-zone d-flex align-items-center justify-content-center w-100 h-100 p-2 position-absolute rounded"})
}
var staticRenderFns = []

export { render, staticRenderFns }